import { ThumbnailButton as ThumbnailButtonStyled } from "../styled"
import { ComponentProps } from "."

const ThumbnailButton = ({ children, isPressed, onClick }: ComponentProps) => (
  <ThumbnailButtonStyled
    aria-pressed={isPressed}
    onClick={onClick}
    type="button"
  >
    {children}
  </ThumbnailButtonStyled>
)

export default ThumbnailButton
